'use client';

import { useTranslations } from 'next-intl';

import { getViberUrl } from '@/lib/contact';
import { cn } from '@/lib/utils';

interface ViberLinkProps {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

/**
 * Personal Viber chat. Custom schemes cannot be opened via HTTP 302, so `href`
 * is the `viber://chat?number=` deep link (digits only, same as Viber's own
 * personal-chat format).
 */
export function ViberLink({ children, className, ariaLabel }: ViberLinkProps) {
  const t = useTranslations('common.phoneReveal');

  return (
    <a href={getViberUrl()} className={cn(className)} aria-label={ariaLabel ?? t('viberLabel')}>
      {children}
    </a>
  );
}
